import { createActions } from 'redux-actions';

import types from 'state/ui/actionTypes';

const { ui } = createActions({
  [types.toggleMainMenu$]: () => ({}),
  [types.closeMainMenu$]: () => ({}),
  [types.toggleSecondaryMenu$]: () => ({}),
  [types.toggleAddressModal$]: ({ shipmentKey, stopType, isEditMode }) => ({
    shipmentKey,
    stopType,
    isEditMode,
  }),
  [types.toggleNewAddressModal$]: () => ({}),
  [types.togglePaymentDataPendingModalOpened$]: () => ({}),
  [types.togglePaymentDataDeniedModalOpened$]: () => ({}),
  [types.toggleLoadingAddresses$]: ({ shipmentKey, stopType }) => ({
    shipmentKey,
    stopType,
  }),
  [types.toggleCancelOrderModalOpened$]: ({ order }) => ({ order }),
  [types.toggleModalFaqs$]: () => ({}),
  [types.setFormTooltip$]: ({ key, content, delay }) => ({
    key,
    content,
    delay,
  }),
  [types.CHANGE_FORM_TOOLTIPS_DATA]: (data) => ({ data }),
  [types.clearFormTooltip$]: ({ key }) => ({ key }),
  [types.SET_FEEDBACK]: ({ feedback, success = true, params = {} }) => ({
    feedback,
    success,
    params,
  }),
  [types.ON_SCROLL_TOP]: () => ({}),
  [types.ON_SCROLL]: () => ({}),
  [types.setFinishedPaymentData$]: ({ newValue }) => ({ newValue }),
  [types.setCatalogStepName$]: ({ newValue }) => ({ newValue }),
});

export default ui;
